export default class Map {
    constructor(options) {
        const { element } = options;
        this._element = element;

        this.init();
    }

    _getCoords() {
        const coords = this._element.data('coords');
        const arrCoords = coords && typeof coords === 'string' && coords.split(',');

        return arrCoords.length ? arrCoords : null;
    }

    _addPlacemark(data) {
        const placemark = new ymaps.Placemark(data);
        this._map.geoObjects.add(placemark);
    }

    _createMap(settings) {
        const elementId = this._element[0].id;

        this._map = new ymaps.Map(elementId, settings);
        this._map.behaviors.disable('scrollZoom');
        this._map.controls.add('zoomControl');
        this._addPlacemark(settings.center);
    }

    init() {
        const center = this._getCoords();

        if (!center) return;

        this._createMap({
            center,
            zoom: 13,
            controls: []
        });
    }
}



// WEBPACK FOOTER //
// ./components/map.js